import React, { useEffect } from "react";
import styled from "@emotion/styled";
import { GetServerSidePropsContext } from "next";
import Head from "next/head";
import { useTranslations } from "next-intl";
import { useRouter } from "next/router";
import ForgotPasswordForm from "@components/forgot-password-form";
import { CPagesPath } from "shared/models/const/pages-path";
import { useAppSelector } from "custom-hooks/redux.hooks";
import { en,es} from "@lang"

export async function getServerSideProps({
  locale,
}: GetServerSidePropsContext) {
  return {
    props: {
      messages: locale === "es" ? es : en,
    },
  };
}

export default function LoginPage(props: any) {
  const router = useRouter();
  const titleT = useTranslations("title-pages");
  const user = useAppSelector((state) => state.Auth.user);

  function onSuccess() {
    router.push(CPagesPath.es.home);
  }

  useEffect(() => {
    if (user) router.push(CPagesPath.es.profile);
  });

  return (
    <>
      <Head>
        <title>{titleT("forgot-password")}</title>
      </Head>
      <Center>
        <Content>
          <ForgotPasswordForm onClose={onSuccess} />
        </Content>
      </Center>
    </>
  );
}

const Center = styled.div`
  display: grid;
  place-content: center;
  height: var(--main-height);
  padding: 20px;
`;

const Content = styled.div`
  background-color: white;
  max-width: 600px;
  padding: 70px 20px 20px;
  border-radius: 40px;
  box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.13);
`;
